import { IoMdClose } from "react-icons/io";
import nodeinstance from "../../../../nodeInstance";
import { useState } from "react";
import { setAppError } from "../../../../store/userSlice";
import { useDispatch } from "react-redux";
import { getVisasummaryData } from "../../../../store/Api";

export default function Visastockreverse({
  setPopUpopen,
  showPromptElement,
  propData,
}) {
  console.log("Data to be seen here......", propData);
  const dispatch = useDispatch();
  const Nodetoken = localStorage.getItem("nodeToken");
  const [visaCount, setVisaCount] = useState();
  const [reason, setReason] = useState();
  console.log("propDatapropData", propData);
  const onSubmit = async () => {
    const reqObject = {
      reverse_count: visaCount,
      reason_for_visa_return: reason,
    };
    const checkCount =
      propData.total_visa -
      (parseInt(propData.allocated) +
        (parseInt(propData.visa_return_requested_qty) > 0
          ? parseInt(propData.visa_return_requested_qty)
          : 0) +
        (parseInt(propData.visa_return_approval_qty) > 0
          ? parseInt(propData.visa_return_approval_qty)
          : 0));

    if (visaCount <= 0) {
      dispatch(
        setAppError({
          msg: "Visa reverse count must be greater than 0",
        })
      );
      return;
    }
    if (visaCount > checkCount) {
      dispatch(
        setAppError({
          msg: `You can only reverse up to ${checkCount} `,
        })
      );
      return;
    }
    const response = await nodeinstance.put(
      `/dashboard/visa-stock/reverseVisas/${propData.vrf_id}`,
      reqObject,
      {
        headers: { Authorization: `Bearer ${Nodetoken}` },
      }
    );
    if (response.status === 200) {
      setPopUpopen(false);
      dispatch(
        setAppError({
          msg: "Updated successfully..",
          color: "success",
        })
      );
      dispatch(getVisasummaryData(Nodetoken));
    }
  };
  return (
    <>
      <div
        className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
          showPromptElement ? "flex" : "hidden"
        }`}
      >
        <div className="max-w-lg w-full h-auto   rounded-md bg-white/95 flex  flex-col p-4 relative">
          <div className="flex justify-between items-center w-full">
            <h1
              className="text-md font-semibold cursor-pointer"
              onClick={() => {
                setPopUpopen(false);
              }}
            >
              <IoMdClose />
            </h1>
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              VISA REVERSE COUNT
            </label>
            <input
              type="number"
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              onChange={(e) => {
                setVisaCount(e.target.value);
              }}
            />
          </div>
          <div className="flex flex-col p-2 gap-1 w-full max-w-md">
            <label htmlFor={`addOrEdit-name`} className="text-xs ">
              REASON FOR VISA REVERSE
            </label>
            <input
              className="border-[1px] border-border dark:bg-dark rounded-md p-1 py-2 text-xs"
              onChange={(e) => {
                setReason(e.target.value);
              }}
            />
          </div>
          <div className="flex gap-3 w-full justify-center">
            <button
              className="w-full max-w-xs-ultra py-2 px-5 rounded-md ring-1 ring-red text-white bg-red"
              onClick={() => {
                onSubmit();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
